var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Hero',[_c('div',[_c('h1',{class:_vm.$style.pageNotFoundCode},[_vm._v("404")]),_vm._v(" "),_c('strong',[_vm._v("Страница не найдена")])])]),_vm._v(" "),_c('div',{class:_vm.$style.pageNotFoundDescription},[_vm._v("Страница, на которую Вы хотели перейти, не найдена. Возможно, введен некорректный адрес или страница была удалена.")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b09adcc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PageNotFound.vue
// module id = null
// module chunks = 